import { useClassnames } from '@lumapps/classnames';

import { PLAYER_CLASSNAME } from '../../constants';

export function usePlayerClassnames() {
    return useClassnames(PLAYER_CLASSNAME);
}
